var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 28H28M18.3792 7.08228C18.3792 7.08228 18.3792 9.26178 20.5587 11.4413C22.7382 13.6208 24.9177 13.6208 24.9177 13.6208M9.7595 23.9841L14.3365 23.3302C14.9967 23.2359 15.6085 22.93 16.0801 22.4584L27.0972 11.4413C28.3009 10.2376 28.3009 8.28598 27.0972 7.08228L24.9177 4.90278C23.714 3.69907 21.7624 3.69907 20.5587 4.90278L9.54155 15.9199C9.06997 16.3915 8.76407 17.0033 8.66975 17.6635L8.0159 22.2405C7.8706 23.2576 8.7424 24.1294 9.7595 23.9841Z",
    stroke: "#0085FF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.ab6f0f65df8b6a783ed8693ea227454e.svg";
export { ForwardRef as ReactComponent };